// Teléfonos de México: 10 dígitos (lada + número). Formato de despliegue: (686) 526-9912
// La API recibe y guarda solo dígitos.
export const PHONE_DIGITS = 10;
export const PHONE_PLACEHOLDER = "(686) 526-9912";

export const toPhoneDigits = ( value ) => ( value || "" ).replace( /\D/g, "" );

// Máscara progresiva mientras se escribe; descarta lo que pase de 10 dígitos
export const maskPhone = ( value ) => {
    const digits = toPhoneDigits( value ).slice( 0, PHONE_DIGITS );
    if ( digits.length <= 3 ) return digits;
    if ( digits.length <= 6 ) return `(${digits.slice( 0, 3 )}) ${digits.slice( 3 )}`;
    return `(${digits.slice( 0, 3 )}) ${digits.slice( 3, 6 )}-${digits.slice( 6 )}`;
};

// Para mostrar: solo formatea números completos; cualquier otro valor se deja tal cual
export const formatPhone = ( phone ) => toPhoneDigits( phone ).length === PHONE_DIGITS ? maskPhone( phone ) : phone;
